import useSWR from 'swr';

import httpApi from 'hooks/api/httpApi';

import type RefundProductDto from '../models/RefundProductDto';

const ENDPOINT = '/api/v1/products-return';

interface GetRefundProductsResponse {
    total_count: number;
    data: RefundProductDto[];
}

const getRefundProducts = async (
    url: string
): Promise<GetRefundProductsResponse> => {
    const response = await httpApi.get<GetRefundProductsResponse>(url);

    return response.getData();
};

type UseRefundProductsSWR = (props: {
    sku: string;
    page: number;
    size?: number;
}) => {
    refundProducts?: RefundProductDto[];
    totalCount?: number;
    loading: boolean;
};

const useRefundProductsSWR: UseRefundProductsSWR = (props) => {
    const { sku, page, size = 12 } = props;

    const getKey = () => {
        const params = new URLSearchParams({
            page: page.toString(),
            size: size.toString(),
        });

        if (sku !== '') {
            params.append('sku', sku);
        }

        return `${ENDPOINT}?${params.toString()}`;
    };

    const { data, isLoading } = useSWR(getKey(), getRefundProducts, {
        // dedupingInterval: 600000, // 10min
        errorRetryCount: 3,
        // revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
    });

    return {
        refundProducts: data?.data,
        totalCount: data?.total_count,
        loading: isLoading,
    };
};

export default useRefundProductsSWR;
